export default "__VITE_ASSET__CSJdeqoQ__"